import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import Form from './components/Form';
import PageMessage from './components/PageMessage';
import ErrorTypes from './@types/ErrorTypes';
import { init as initCore } from './services/core/config';
import { getLink } from './utils';
import Header from './components/header';
import ActionRegister from './components/ActionRegister';
import LoginModal from './components/LoginModal';
import { createCookie } from './utils/cookieUtil';
import { AccountUnderReviewModal } from './components/Modal/AccountUnderReviewModal';
import { ModalProvider } from './context/AccountUnderReviewModalContext';
import { PasswordLockProvider } from './context/PasswordLockContext';
import { PasswordLockModalWrapper } from './components/Modal/PasswordLockModal/PasswordLockModalWrapper';
import { FirstAccessModal } from './components/Modal/FirstAccessModal';
import { FirstAccessModalProvider } from './context/FirstAccessModalContext';

const App: React.FC = () => {
  const [loadCore, setLoadCore] = useState(false);
  const [currentErrorType, setCurrentErrorType] = useState<ErrorTypes>();

  const [isWifiLogin, setIsWifiLogin] = useState(false);
  const [identifierStatus, setIdentifierStatus] = useState<string>('');

  const [modalNotFoundIsOpen, setModalNotFoundIsOpen] = useState(false);
  const [blockPasswordModalIsOpen, setBlockPasswordModalIsOpen] = useState(false);
  const [preRegistrationModalIsOpen, setPreRegistrationModalIsOpen] = useState(false);
  const [firstErrorModalIsOpen, setFirstErrorModalIsOpen] = useState(false);
  const [lastTryModalIsOpen, setLastTryModalisOpen] = useState(false);
  const [typeIdentifierService, setTypeIdentifierService] = useState('');
  const { t } = useTranslation('login_page');
  const [errorTreatment, setErrorTreatment] = useState(false);
  const [invalidDataError, setInvalidDataError] = useState(false);
  const urlParams = useMemo(() => queryString.parse(window.location.search), []);

  useEffect(() => {
    initCore().then(() => {
      setLoadCore(true);
    });

    try {
      const config = JSON.parse(decodeURIComponent(escape(window.atob(window.auth0config))));
      const isWifi = config.dict.signin.title === 'spa-uv-wifi';
      setIsWifiLogin(isWifi);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('fail to get config: ', error);
    }
  }, []);

  // Values obtained in the URL queryParameters
  useEffect(() => {
    if (urlParams.con_id) {
      createCookie({
        name: '_convid',
        value: urlParams.con_id,
      });
    }

    document.cookie = "_convid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_userid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_loginEntryChannel=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_entryPhone=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    document.cookie = "_subEnv=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.smiles.com.br; path=/;";
    if (window.location.search.includes("con_id") && window.location.search.includes("user_id") && window.location.search.includes("login_entry_channel") && window.location.search.includes("entry_phone") && window.location.search.includes("sub_env")) {
      const urlQueryParam = queryString.parse(window.location.search.replaceAll('%253D', '=').replaceAll('%2526', '&').replaceAll('%3D', '&'));
      document.cookie = `_convid=${urlQueryParam.con_id};domain=.smiles.com.br;path=/`;
      document.cookie = `_userid=${urlQueryParam.user_id};domain=.smiles.com.br;path=/`;
      document.cookie = `_loginEntryChannel=${urlQueryParam.login_entry_channel};domain=.smiles.com.br;path=/`;
      document.cookie = `_entryPhone=${urlQueryParam.entry_phone};domain=.smiles.com.br;path=/`;
      document.cookie = `_subEnv=${urlQueryParam.sub_env};domain=.smiles.com.br;path=/`;
    }
  }, []);

  useEffect(() => {
    if (identifierStatus) {
      getModalIdentifierStatus();
    }
  }, [identifierStatus]);

  useEffect(() => {
    if (invalidDataError) {
      console.error('Erro : Dados inválidos, tente novamente');
    }
  }, [invalidDataError]);

  function getModalIdentifierStatus() {
    try {
      // if (identifierStatus === 'PRE REGISTRATION') {
      //   setPreRegistrationModalIsOpen(true);
      // } else if (identifierStatus === 'INCOMPL. REGISTRATION PARTNER') {
      //   setPreRegistrationModalIsOpen(true);
      // } else if (identifierStatus === 'PENDING ENROLLMENT') {
      //   setPreRegistrationModalIsOpen(true);
      // } else if (identifierStatus === 'PRE REGISTRATION BANKS') {
        // setPreRegistrationModalIsOpen(true); } else 
      if (identifierStatus === 'USER_NOT_FOUND') {
        setModalNotFoundIsOpen(true);
      } else if (identifierStatus === null || undefined) {
        setModalNotFoundIsOpen(true);
      }
    } catch (e) {
      window.location.href = getLink('mensagem-de-erro');
    }
  }

  function handleRedirectPreRegistrationModalClick() {
    if (typeIdentifierService !== null && typeIdentifierService === 'CPF') {
      window.location.href = getLink('cadastro');
    } else {
      window.location.href = getLink('cadastro');
    }
  }

  function handleBtnErrorTreatment() {
    setErrorTreatment(false);
  }

  return (
    <div className="auth0-wrapper">
      {loadCore && (
        <>
          {errorTreatment ? (
            <PageMessage type="BROKENSUITCASE" onClickErrorTreatment={handleBtnErrorTreatment} />
          ) : (
            <>
              <ModalProvider>
                <PasswordLockProvider>
                  <FirstAccessModalProvider>
                    <Header />
                    <div className="content">
                      <div className="form-left-wrapper">
                        <main>
                          <div className="main-content">
                            <h3>{t('title')}</h3>
                            <p>{t('description')}</p>

                            <Form
                              setInvalidDataError={setInvalidDataError}
                              setTypeIdentifierService={setTypeIdentifierService}
                              setIdentifierStatus={setIdentifierStatus}
                              setErrorTreatment={setErrorTreatment}
                              onSubmitFinish={({ hasError, errorType }) => {
                          setCurrentErrorType(errorType);
                        }}
                              isWifiLogin={isWifiLogin}
                            />
                          </div>
                        </main>
                      </div>
                      <ActionRegister />

                      <LoginModal
                        isOpen={invalidDataError}
                        toggle={() => {
                    setInvalidDataError(false);
                  }}
                        onClick={() => {
                    setInvalidDataError(false);
                  }}
                        onExit={() => {
                    setInvalidDataError(false);
                  }}
                        modalTitle={t('incorrect_data.title')}
                        modalDescription={t('incorrect_data.subtitle')}
                        text={t('incorrect_data.button')}
                        secondaryButton={false}
                        onClickSecondaryButton={() => ''}
                        type="right"
                        secondaryBtnText=""
                      />

                      <LoginModal
                        isOpen={preRegistrationModalIsOpen}
                        toggle={() => {
                    setPreRegistrationModalIsOpen(false);
                  }}
                        onClick={() => {
                    setPreRegistrationModalIsOpen(false);
                    handleRedirectPreRegistrationModalClick();
                  }}
                        onExit={() => {
                    setPreRegistrationModalIsOpen(false);
                  }}
                        modalTitle={t('pre_registrated_user.title')}
                        modalDescription={t('pre_registrated_user.subtitle')}
                        text={t('pre_registrated_user.button')}
                        secondaryButton={false}
                        onClickSecondaryButton={() => ''}
                        type="right"
                        secondaryBtnText=""
                      />

                      <LoginModal
                        isOpen={modalNotFoundIsOpen}
                        toggle={() => {
                    setModalNotFoundIsOpen(false);
                  }}
                        onClick={() => {
                    setModalNotFoundIsOpen(false);
                  }}
                        onExit={() => {
                    setModalNotFoundIsOpen(false);
                  }}
                        showHyperlink
                        hyperLinkText={t('user_not_found.forgot_password_button')}
                        onClickHyperLink={() => {
                    window.location.href = getLink('cadastro');
                  }}
                        type="right"
                        modalTitle={t('user_not_found.title')}
                        modalDescription={t('user_not_found.subtitle')}
                        text={t('user_not_found.button')}
                      />
                    </div>

                    <AccountUnderReviewModal />
                    <FirstAccessModal />
                    <PasswordLockModalWrapper />
                  </FirstAccessModalProvider>
                </PasswordLockProvider>
              </ModalProvider>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default App;
